import { themeColors } from "../config";
import { TYPES } from "../segments/FileSystem";

class File {
  #data;
  #extra;
  #parent;
  constructor(name, hash, parent, data, ext = null, extra = {}) {
    this.#parent = parent;
    this.metadata = {
      name: name,
      hash: hash,
      size: data.length,
      type: TYPES.FILE,
      ext: ext,
    };
    this.#data = data;
    this.#extra = extra;
  }

  changeParent(parent) {
    this.#parent = parent;
  }

  changeName(name) {
    this.metadata.name = name;
  }

  changeExt(ext) {
    this.metadata.ext = ext;
  }

  saveData(data) {
    this.#data = data;
    this.metadata.size = data.length;
  }

  getMetaData() {
    return this.metadata;
  }

  getExtra() {
    return this.#extra;
  }

  getType() {
    return this.metadata.type;
  }

  getName() {
    return this.metadata.name;
  }

  getExt() {
    return this.metadata.ext;
  }

  getHash() {
    return this.metadata.hash;
  }

  getSize() {
    return this.#data.length;
  }

  getData() {
    return this.#data;
  }

  getParent() {
    return this.#parent;
  }

  clone() {
    return new File(
      this.metadata.name,
      this.metadata.hash,
      this.#parent,
      this.#data
    );
  }
}

export default File;
